
import React from 'react';
function Team() {
  return (
    <section className="tc-team-style1">
      <div className="container">
        <div className="mb-80">
          <h2 className=" team-heading"> Meet our top-notch experts </h2>
        </div>
        <div className="members">
          <div className="row">
            <div className="col-lg-2">
              <div className="member-colmn">
                <a href="#" className="team-card wow zoomIn">
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/04.png"
                      alt="Atul Dwivedi"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '} Atul Dwivedi
                     <br /> Principal Architect {' '}
                  </h5>
                </a>
                 <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.7s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/09.png"
                      alt="Zeeshan Imam"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '} Zeeshan Imam
                     <br /> Head - Services {' '}
                  </h5>
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="member-colmn">
                <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.2s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/02.png"
                      alt="Biljana Georgieva"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '}
                    Biljana Georgieva <br />Head - Luxury Interior{' '}
                  </h5>
                </a>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="member-colmn">
                <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.3s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/03.png"
                      alt="Krstro Cetkovic"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '}
                    Krsto Cetkovic<br />3D visualizer{' '}
                  </h5>
                </a>
                <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.4s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/05.png"
                      alt="Shaifali Agarwal"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '} Shaifali Agarwal
                     <br /> Head - Corp. Interior & Retail {' '}
                  </h5>
                </a>
              </div>
            </div>
            <div className="col-lg-2 order-last order-lg-0">
              <div className="member-colmn">
                <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.5s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/08.png"
                      alt="Sreenivas Reddy"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '} Sreenivas Reddy
                     <br /> Project Architect {' '}
                  </h5>
                </a>
                <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.5s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/07.png"
                      alt="Ajay Dev"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '} Ajay Dev
                     <br /> Architect - Estimate & Planner {' '}
                  </h5>
                </a>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="member-colmn">
                <a
                  href="#"
                  className="team-card wow zoomIn"
                  data-wow-delay="0.7s"
                >
                  <div className="img">
                    <img
                      src="/home1/assets/img/team/06.png"
                      alt="Sandeep Singh"
                      className="img-cover"
                    />
                  </div>
                  <h5 className="title">
                    {' '} Sandeep Singh
                     <br /> Project Manager {' '}
                  </h5>
                </a>
               
              </div>
            </div>
          </div>
        </div>
        <div className="numbers">
          <div className="row gx-5">
            <div className="col-lg-4">
              <div className="number-card wow fadeInUp" data-wow-delay="0.2s">
                <h3 className="perc"> 95% </h3>
                <p>
                  {' '}
                  Happy Customer and <br /> Repeating{' '}
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="number-card wow fadeInUp" data-wow-delay="0.4s">
                <h3 className="perc"> 126 </h3>
                <p>
                  {' '}
                  Projects Completed in <br /> 15 Years{' '}
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="number-card wow fadeInUp" data-wow-delay="0.6s">
                <h3 className="perc"> 25 </h3>
                <p>
                  {' '}
                  Architects and <br /> High Qualified Crafters{' '}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
